import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { Proteins } from 'models/Pet'
import { FrozenRecipeDetail } from 'features/Recipes/FrozenRecipeDetail'

export default function RecipePage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Duck Recipe',
    image: [
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fduck-bowl.f372615b.webp&w=3840&q=75',
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ffrozen-duck-pouch-white-wrapper.3aadc780.webp&w=3840&q=75',
    ],
    description:
      'A fan favorite! Highly digestible while supporting longevity + healthy aging. Formulated by a PhD nutrition expert to be complete + balanced for dogs of all life stages. (Includes turkey.)',
    brand: {
      '@type': 'Brand',
      name: 'We Feed Raw',
    },
    manufacturer: {
      '@type': 'Organization',
      name: 'We Feed Raw',
    },
    url: 'https://wefeedraw.com/recipes/duck',
    additionalProperty: [
      {
        '@type': 'PropertyValue',
        name: 'Protein',
        value: 'Duck',
      },
      {
        '@type': 'PropertyValue',
        name: 'Duck Quality',
        value: 'Made with Cage-Free Duck',
      },
      {
        '@type': 'PropertyValue',
        name: 'Antibiotics',
        value: 'Minimally Processed',
      },
      {
        '@type': 'PropertyValue',
        name: 'Harvesting Method',
        value: 'Humanely Harvested',
      },
    ],
    offers: {
      '@type': 'Offer',
      price: '10.71',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition',
      seller: {
        '@type': 'Organization',
        name: 'We Feed Raw',
      },
      url: 'https://wefeedraw.com/recipes/duck',
      shippingDetails: {
        '@type': 'OfferShippingDetails',
        shippingRate: {
          '@type': 'MonetaryAmount',
          value: '0.00',
          currency: 'USD',
        },
        shippingDestination: {
          '@type': 'DefinedRegion',
          addressCountry: 'US',
        },
      },
      priceSpecification: [
        {
          '@type': 'UnitPriceSpecification',
          price: '17.85',
          priceCurrency: 'USD',
          priceType: 'ListPrice',
        },
        {
          '@type': 'UnitPriceSpecification',
          price: '10.71',
          priceCurrency: 'USD',
          priceType: 'SalePrice',
        },
      ],
    },
    isSimilarTo: [
      {
        '@type': 'Product',
        name: 'Beef Recipe',
        url: 'https://wefeedraw.com/recipes/beef',
      },
      {
        '@type': 'Product',
        name: 'Chicken Recipe',
        url: 'https://wefeedraw.com/recipes/chicken',
      },
      {
        '@type': 'Product',
        name: 'Turkey Recipe',
        url: 'https://wefeedraw.com/recipes/turkey',
      },
      {
        '@type': 'Product',
        name: 'Lamb Recipe',
        url: 'https://wefeedraw.com/recipes/lamb',
      },
      {
        '@type': 'Product',
        name: 'Chicken Recipe',
        url: 'https://wefeedraw.com/recipes/freeze-dried-raw-chicken',
      },
      {
        '@type': 'Product',
        name: 'Beef Recipe',
        url: 'https://wefeedraw.com/recipes/freeze-dried-raw-beef',
      },
    ],
  }

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('recipes:DUCK.page-title')}</title>
        <meta name="title" content={t('recipes:DUCK.meta-title')} />
        <meta
          name="description"
          content={t('recipes:recipe-detail-meta-description', {
            protein: Proteins.DUCK.toLowerCase(),
          })}
        />
        <link rel="canonical" href="https://wefeedraw.com/recipes/duck" />
        <script
          id="schema-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLdString }}
        />
      </Head>

      <main>
        <FrozenRecipeDetail protein={Proteins.DUCK} />
      </main>
    </div>
  )
}
